/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions
import { Button } from "../../b";
import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'shortener';

/**
 * This is the component description.
 */
const Shortener = ({
  id,
  className: userClassName,
  style,
  children,
  // ...otherProps

  as: Element,
  limit,
  separator,
  countLetters
}) => {
  const [displayFull, setDisplayFull] = useState(false);
  const text = children || '';
  const excerpt = countLetters ? text.slice(0, limit) : text.split(separator).slice(0, limit).join(separator);
  const doShorten = countLetters ? text.length > limit : text.split(separator).length > limit;
  return /*#__PURE__*/React.createElement(Element, {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
    // {...otherProps}
  }, text && !displayFull && doShorten ? /*#__PURE__*/React.createElement(React.Fragment, null, excerpt, '... ', /*#__PURE__*/React.createElement(Button, {
    isSimple: true,
    className: "s-2",
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      setDisplayFull(true);
    }
  }, "Show")) : text);
};
Shortener.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   * Which html tag to use
   */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // as: PropTypes.string,

  /**
   * How many separated elements to accept before the read more.
   * This may mean how many words, or how many letters if `countLetters=true`
   */
  limit: PropTypes.number,
  /**
   * Which separator to use to count words. This is only used in if `countLetters=false`.
   */
  separator: PropTypes.string,
  /**
   * Whether to count letters instead of using a split
   */
  countLetters: PropTypes.bool
};
Shortener.defaultProps = {
  // someProp:false
  as: 'span',
  separator: ' ',
  limit: 20,
  countLetters: false
};
export default Shortener;